import React, {Component} from 'react';
import banner from '../assets/json/widget/banner-details.json';
import '../assets/css/style.css';
import {Grid, Button, Modal} from 'semantic-ui-react';
import logo_lmt from '../assets/images/lmt-logo.png';
import logo_lmt_wht from '../assets/images/lmt-logo-wht.png';
import bannerClouds from '../assets/images/home/banner-clouds.png';
import play from '../assets/images/play.png';
import ReactPlayer from 'react-player';
import {Redirect} from 'react-router';

import data from '../assets/json/travelstories/video.json';



class PageBanner extends Component{

  constructor(props) {
    super(props);
    this.state = {
		name: this.props.pagename,
		title: banner.title[this.props.pagename],
		desc: banner.desc[this.props.pagename],
		background: banner.background[this.props.pagename],
		menuCSS: 'header-wrapper',
		lmtLogo: logo_lmt_wht,
		redirect: false,
		routeLink: '',
		open: false
    }
  }

  componentDidMount() {
	  window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
	  window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
		var tempContent = document.getElementById('banner-content-wrapper').clientHeight;
		var eScrollTop = document.documentElement.scrollTop ;
		var top = 0;
		var bottom = top + tempContent;

		if (eScrollTop===0 || (top < eScrollTop && bottom > eScrollTop)) {
			this.setState({menuCSS: "header-wrapper"});
			this.setState({lmtLogo: logo_lmt_wht});
			//console.log("if" + eScrollTop + "===0 ||" + top + "<" + eScrollTop + "&&" + bottom + ">" + eScrollTop);
		} else {
			this.setState({menuCSS: "header-wrapper header-wrapper-white"});
			this.setState({lmtLogo: logo_lmt});
			//console.log("else" + eScrollTop + "===0 ||" + top + "<" + eScrollTop + "&&" + bottom + ">" + eScrollTop);
		}
	}

	goToWhyChooseLM = (id) => {
		this.setState({
			redirect: true,
			routeLink: id === 1 ? '/tours' : id === 2 ? '/tours/TourHolyLand' : ''
		});
	}

	openModal = () => this.setState({ open: true });
	closeModal = () => this.setState({ open: false });


	

	render(){
		const {redirect, routeLink, background} = this.state;
		
		return (
			<>
				{ redirect &&
					<Redirect push to={routeLink}/>
				}
				<Grid className="banner-wrapper" id="banner-wrapper" >					
					<Grid.Column width={16} className="banner-grid" >
						<div className="vertical-center-wrapper">
							<div className="display-table" >
								<div className="display-table-cell" style={{background:"url('"+background+"')"}}>
									<div className="banner-content-wrapper" id="banner-content-wrapper" onScroll={this.handleScroll} >
										{this.props.pagename === "Tours" ? <label className="banner-lbltitle">Featured tour:</label> : ""}
										
										{this.state.title.map((paragraph, i) => (
											<h1 key={i} className="title">{paragraph}</h1>
											)
										)}
										
										{this.state.desc.map((paragraph, i) => (
											<div key={i} className="banner-text">{paragraph}</div>
											)
										)}
										
										{this.props.pagename === "Home" ? <Button color='orange' onClick={() => this.goToWhyChooseLM(1)}>Learn more</Button>: ""}
										{this.props.pagename === "Tours" ? <Button color='orange' onClick={() => this.goToWhyChooseLM(2)}>See full details</Button>: ""}
										{this.props.pagename === "TravelStories" ?
											<div className="travel-vlog-wrapper align-center">
												<button href="#" onClick={this.openModal} className="link-video"><img src={play} alt="play" className="play-button"/></button>
											</div>
											: ""
										}
									
									</div>
									{this.props.pagename === "Home" ?<img src={bannerClouds} className="banner-clouds" alt="clouds" /> : ""}
									{this.props.pagename === "About" ?
										<div className="our-people-wrapper">
											<h1>Our People</h1>
											<div className="banner-text our-people-content">
												Great people make us who we are. We respect our people and encourage their ideas and creativity. We are committed to
												maintaining our amazing and diverse team of passionate travel specialists, who challenge each other and demonstrate 
												a <span className="bold">'can do'</span> attitude.
											</div>
										</div>
										: ""
									}
									{this.props.pagename === "TravelStories" ?
										<div className="arrow-more">
											<p className="para-content-orange"><span><i className="chevron down icon"></i></span></p>
										</div>
										: ""
									}
									

								</div>
							</div>
						</div>

						
					</Grid.Column>					
				</Grid>
				<Modal basic open={this.state.open} onClose={this.closeModal} size='large' dimmer='blurring' closeIcon closeOnDimmerClick={false}>
					<Modal.Header>Sydney with the Pangilinans</Modal.Header>
					<Modal.Content className="modal-video-wrapper">
						<ReactPlayer
							url={data.source + "?rel=0&amp;controls=0&amp;showinfo=0;modestbranding=1"}
							width='100%'
							height='100%'
							playing={true}
							controls={true}
							loop={true}
						/>
						
					</Modal.Content>
				</Modal>
			</>
		);
	}
}

export default PageBanner;